import React, { Component } from 'react';

import DownArrowBlue from '../../../../assets/icons/dropdown-arrow-blue.png';
import RightIcon from '../../../../assets/icons/check-green.svg';
import WrongIcon from '../../../../assets/icons/incorrect-answer.svg';
import CheckIconWhite from '../../../../assets/icons/check-white.svg';
import EditIcon from '../../../../assets/icons/icon-edit-blue.svg';
import DeleteIcon from '../../../../assets/icons/icon-delete-red.svg';

import { IsListEmpty } from '../../../../utilities/CommonMethods';

import classes from './AccordionItem.module.css';


class AccordionItem extends Component {

    state = {
        opened: false,
        itemClicked: false,
    }

    changeItemStatus = () => {
        let status = !this.state.opened;
        this.setState({ opened: status, itemClicked: true });

    }

    componentDidUpdate(prevProps) {
        if (prevProps.collapseAll !== this.props.collapseAll) {
            const status = this.props.collapseAll;
            this.setState({ opened: !status });
        }
    }

    render() {
        const options = !IsListEmpty(this.props.problemData.options) ? this.props.problemData.options.map((option, index) => {
            return <li key={index} className={classes.SubOptionItem}>

                <div className={[classes.CheckIconDiv,
                this.props.questionType === "single" ? classes.Round : classes.Square,
                option.selected ? classes.Active : null].join(' ')}>
                    <img src={CheckIconWhite} alt="Option Checked Icon" className={[classes.CheckIcon, option.selected ? classes.ShowImage : null].join(' ')} />
                </div>

                {
                    option.type === 'text'
                        ? <span className={option.selected ? classes.SelectedOptionText : null}>{option.option}</span>
                        : <img src={option.option} alt="Option Thumbnail" className={classes.OptionImage} />
                }
                {
                    option.optionStatus === 'correct' || option.correct //option.correct
                        ? <img src={RightIcon} alt="Correct Option" className={classes.CorrectIcon} />
                        : option.optionStatus === 'incorrect' || option.incorrect //option.incorrect
                            ? <img src={WrongIcon} alt="Incorrect Option" className={classes.InCorrectIcon} />
                            : null
                }
            </li>
        }) : null;

        return (
            <div className={[classes.AccordionItem, this.state.opened === true ? classes.AccordionItemOpened : null].join(' ')}>
                <div className={classes.AccordionItemLine} onClick={this.changeItemStatus}>
                    <p className={classes.AccordionItemTitle}>
                        Question {this.props.pos + 1}
                    </p>

                    {
                        !this.props.forInstructor
                            ? <p className={[classes.Status,
                            this.props.problemData.status === "NOT ATTEMPTED" ? classes.NotAttempted : '',
                            this.props.problemData.status === "INCORRECT" ? classes.Incorrect : '',
                            this.props.problemData.status === "CORRECT" ? classes.Correct : ''].join(' ')}>
                                {this.props.problemData.status}</p>
                            : null
                    }
                    <p className={classes.MaxScore}>{this.props.problemData.maxScore}<br /><span>Max Score</span></p>
                    {
                        this.props.forInstructor
                            ? <div className={classes.IconsContainer}>
                                <img src={EditIcon} alt="Problem Edit Icon" className={classes.Icons} onClick={() => this.props.onEditProblemClick(this.props.problemData.id, this.props.pos)} />
                                {this.props.forPMPage
                                    ? <img src={DeleteIcon} alt="Problem Delete Icon" className={classes.Icons} onClick={(event) => this.props.onDeleteProblemClick(event, this.props.problemData.id, this.props.pos)} /> : null}
                            </div>
                            : null
                    }
                    <span className={classes.AccordionItemIcon} >
                        <img src={DownArrowBlue} alt='accordion-down-arrow' />
                    </span>
                </div>
                <div className={classes.AccordionItemInner} >
                    <div className={classes.AccordionItemContent} >
                        {/* <p className={classes.Problem}>{this.props.problemData.problem}</p> */}
                        <div
                            className={classes.Problem}
                            dangerouslySetInnerHTML={{ __html: this.props.problemData.problem }}>
                        </div>
                        <ul className={classes.AccordionItemTopics} >
                            {options}
                        </ul>
                    </div>
                </div>
            </div>
            // <div>items</div>
        )
    }
}

export default AccordionItem;